export const getFileSizeString = (size: number) => {
  const ext = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  // eslint-disable-next-line no-cond-assign
  while ((size = size / 1024) > 1) i++;
  return `${(size * 1024).toFixed(1)} ${ext[i]}`;
};

/**
 * Extracts the file extension from a given file path or URL.
 *
 * This function uses a regular expression to find the last dot (`.`) in the
 * string and extracts the substring following it. If the path does not have
 * an extension, it defaults to `"Unknown"`. The leading dot (`.`) is removed
 * from the extension in the returned value.
 *
 * @param path - The file path or URL to extract the extension from.
 * @returns The file extension without the leading dot, or an empty string
 * if no valid extension is found.
 */
export const getExt = (path: string) =>
  (path.match(/.[^.]+$/)![0] ?? ".Unknown").startsWith(".") ? (path.match(/.[^.]+$/)![0] ?? ".Unknown").slice(1) : "";
